module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loaded) ? _c('img', {
    attrs: {
      "src": _vm.src,
      "alt": ""
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2fada80","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImgLoaded.vue
// module id = 619
// module chunks = 1